import * as React from "react";
import {firebaseApp} from "../firebaseClient";
import App from "./app";
import {Container} from "@chakra-ui/react";
import WaitScreen from "../components/WaitScreen";

if (firebaseApp !== undefined) {
    console.log("Firebase initialized");
}


const Home: React.FC = () => {
    return <Container maxWidth={"full"} maxHeight={"full"} id={"_MainContainer"}
                      style={{height: "calc(100% - 64px)", display: "flex"}}>
        <WaitScreen>
            <App/>
        </WaitScreen>
    </Container>
}

export default Home;
